<template>
  <el-main class="rh-medform">
    <h1>Pupille</h1>
    <form-tutoratedit :ismedpup="true" :routes="routes" />
  </el-main>
</template>
<script>
import FormTutoratedit from "@/components/rh/formulaires/FormTutoratedit";

export default {
  components: { "form-tutoratedit": FormTutoratedit },
  computed: {
    routes() {
      return {
        tolist: {
          name: "med_pupilles",
          params: { idmed: this.$route.params.idmed },
        },
        evaform: {
          edit: { route: "med_pup_evaluations_edit", params: { ideval: "id" } },
          create: { route: "med_pup_evaluations_create" },
        },
      };
    },
  },
};
</script>
